import React, {useState} from "react";
import Hero2 from "./../../assets/images/hero_2.png";
import Insta from "./../../assets/images/insta.png";
import Profile from "./../../assets/images/profile.png";
import ArrowRight from "./../../assets/images/ArrowCircleRight.png";
import ArrowLeft from "./../../assets/images/ArrowCircleLeft.png";
import "./review.css";
const Review = () => {
  const slides = [
    {
      content:
        "Absolutely loving the results I'm getting with this beauty sponge! It's a game-changer for my makeup routine. The sponge blends my foundation flawlessly, leaving my skin looking airbrushed and smooth. I've noticed a significant improvement in the overall finish of my makeup since incorporating this beauty sponge into my routine. Highly recommended!",
        name: "Aryna Sabalenka",
        prof: "Lecturer",
        image: Profile
    },
    {
      content:
        "It's a game-changer for my makeup routine. The sponge blends my foundation flawlessly, Absolutely loving the results I'm getting with this beauty sponge!  leaving my skin looking airbrushed and smooth. I've noticed a significant improvement in the overall finish of my makeup since incorporating this beauty sponge into my routine. Highly recommended!",
        name: "Sabalenka Aryna",
        prof: "Designer",
        image: "https://cdn2.iconfinder.com/data/icons/business-and-finance-related-hand-gestures/256/face_female_blank_user_avatar_mannequin-512.png"
    },
    {
      content:
        "The sponge blends my foundation flawlessly, leaving my skin looking airbrushed and smooth.Absolutely loving the results I'm getting with this beauty sponge! It's a game-changer for my makeup routine.  I've noticed a significant improvement in the overall finish of my makeup since incorporating this beauty sponge into my routine. Highly recommended!",
        name: "John Doe",
        prof: "Student",
        image: 'https://t4.ftcdn.net/jpg/03/97/18/51/360_F_397185189_AcQiXo8LVt7SIVlEEs7BIakIkeFyhOyh.jpg'
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };
  return (
    <div className="review">
      <div className="review_left">
        <p className="review_heading">
          Customer Raves About Our Beauty Sponge!
        </p>
        <img src={Hero2} alt="" />
      </div>
      <div className="review_right">
        <div className="review_right_header">
          <img src={Insta} alt=" " />
          <p>#Mixybeauty</p>
        </div>
        <p className="review_content">
          {slides[currentIndex].content}
        </p>
        <div className="review_footer">
          <div className="review_footer_right">
            <div>
              <img src= {slides[currentIndex].image} alt=" " width="" className="review_profile"/>
            </div>
            <div>
              <p className="name"> {slides[currentIndex].name}</p>
              <p className="prof"> {slides[currentIndex].prof}</p>
            </div>
          </div>
          <div>
            <button className="review_arrow"  onClick={handlePrev}>
              <img src={ArrowLeft} alt="" />
            </button>

            <button className="review_arrow" onClick={handleNext}>
              <img src={ArrowRight} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
